module.exports = __webpack_public_path__ + "static/media/PRESIDVITALICIODIPLOM50 dpi copia.c169749c.jpg";